/**
 * Smatchy
 * The smatchy API description. Use POST /auth/login to get an access token.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CreateCgvAcceptanceHistoryDto { 
    /**
     * CGV Acceptance id
     */
    cgvAcceptanceId: string;
    /**
     * CGV Version id
     */
    cgvVersionId: string;
    /**
     * CGV version value (ex: v1.0)
     */
    cgvVersion?: number;
    /**
     * Commission history id
     */
    commissionHistoryId?: string;
    /**
     * Commission rate at accepted time
     */
    commissionRate?: number;
    /**
     * User id who updated this record
     */
    updatedById?: string;
    /**
     * User name who updated this record
     */
    updatedBy?: string;
    /**
     * Is CGV accepted or not
     */
    isAccepted?: boolean;
}

